import React from 'react';
import image1 from '@/main/assets/images/homepage/asset@3x.png';
import image2 from '@/main/assets/images/homepage/xnuup_03_Van_large.jpg';
import image3 from '@/main/assets/images/homepage/osman-rana-G7VN8NadjO0-unsplash.jpg';
import image4 from '@/main/assets/images/homepage/shutterstock_2327690811.jpg';
import image5 from '@/main/assets/images/homepage/shutterstock_1831981495.jpg';
import image6 from '@/main/assets/images/homepage/dylan-gillis-KdeqA3aTnBY-unsplash.jpg';

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import { getTranslateByKey } from '@/main/services/utils';

function HomepageAboutScreen() {
  return (
    <S.Container>
      <S.FirstSection $backgroundImage={image1}>
        <TextImage
          backgroundImage={image2}
          title={getTranslateByKey('information.aboutUs')}
          description=""
          positionImage="right"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '540px',
            height: '609px'
          }}
          idImage="id-homepage-about-image-1"
        />
      </S.FirstSection>
      <S.SectionContainer>
        <TextImage
          title={getTranslateByKey('information.homepageAboutUs1')}
          description={getTranslateByKey('information.homepageAboutUs2')}
          positionImage="left"
          backgroundImage={image3}
          imageProps={{
            clipBorderImage: 'bottom',
            width: '530px',
            height: '340px'
          }}
          idImage='id-homepage-about-image-3'
        />
        <TextImage
          title={getTranslateByKey('information.homepageAboutUs3')}
          description={getTranslateByKey('information.homepageAboutUs4')}
          positionImage="right"
          backgroundImage={image4}
          imageProps={{
            clipBorderImage: 'left',
            width: '410px',
            height: '532px'
          }}
          idImage='id-homepage-about-image-4'
        />
        <TextImage
          title={getTranslateByKey('information.homepageAboutUs5')}
          description={getTranslateByKey('information.homepageAboutUs6')}
          positionImage="left"
          backgroundImage={image5}
          imageProps={{
            clipBorderImage: 'bottom',
            width: '530px',
            height: '340px'
          }}
          idImage='id-homepage-about-image-5'
        />
        <TextImage
          title={getTranslateByKey('information.homepageAboutUs7')}
          description={getTranslateByKey('information.homepageAboutUs8')}
          positionImage="right"
          backgroundImage={image6}
          imageProps={{
            clipBorderImage: 'bottom',
            width: '530px',
            height: '340px'
          }}
          idImage='id-homepage-about-image-6'
        />
      </S.SectionContainer>
    </S.Container>
  );
}

export default HomepageAboutScreen;
